<nav automation-id="header-nav-1" #navbar class="navbar active">
  @if (_glob.openCart$ | async) {
    <div class="grey-overlay">
    </div>
  }
  <div class="container-fluid" [ngClass]="(_glob.submitOrderProcess$|async)? 'no-pointers' : 'all-pointers'">
    <div class="navbar-header">
      <a automation-id="header-a-2" href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"
      (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a automation-id="header-a-3" href="#" onClick="return false;" class="bars"></a>
      <a automation-id="header-a-4" class="navbar-brand" routerLink={{homePage}}>
        @if ((_glob.onSidebarOpen|async)!='hide') {
          <img automation-id="header-img-5" src="assets/images/pages/MaleMan-sidebar.png"
            [ngClass]="(_glob.onSidebarOpen|async)!='hide' && !(_glob.onSidebarOpen|async) ? 'sidebar-close' : 'sidebar-open'"
            alt="" />
        }
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngClass]="isNavbarCollapsed ? '' : 'show'">
      <!-- <ul automation-id="header-ul-6" class="float-start collapse-menu-icon">
      <li automation-id="header-li-7">
        <button automation-id="header-button-8" mat-button (click)="callSidemenuCollapse()"
          class="sidemenu-collapse nav-notification-icons"> <i automation-id="header-i-9"
          class="material-icons-outlined icon-color">
          menu
        </i></button>
      </li>
    </ul> -->
    <ul automation-id="header-ul-10" class="nav navbar-nav navbar-right">
      <!-- Full Screen Button -->
      <!-- <li  automation-id="header-li-11" class="fullscreen">
      <button  automation-id="header-button-12" mat-button class="nav-notification-icons" (click)="callFullscreen()"> <i  automation-id="header-i-13"
        class="material-icons-outlined icon-color">
        fullscreen
      </i></button>
    </li> -->
    <!-- #END# Full Screen Button -->
    <!-- #START# Notifications-->
    <li automation-id="header-li-14">

      <button automation-id="header-button-15" mat-icon-button class="mt-2 nav-notification-icons"
        routerLink="/support/contact-us" style="    margin-right: 8px !important;">
        <mat-icon automation-id="header-mat-icon-16"
        style="vertical-align: middle; color: #DFF4FB;">help_outline</mat-icon>

      </button>
    </li>

    <li automation-id="header-li-17" hidden>
      <!--  -->
      <button automation-id="header-button-18" mat-icon-button class="mt-2 nav-notification-icons">
        <mat-icon automation-id="header-mat-icon-19"
        style="vertical-align: middle; color: #DFF4FB;margin-right: 10px;">notifications</mat-icon>

      </button>

      <mat-menu automation-id="header-mat-menu-20" #notificationMenu="matMenu" class="nfc-menu">
        <div class="nfc-header">
          <h5 automation-id="header-h5-21" class="mb-0">Notitications</h5>
          <a automation-id="header-a-22" class="nfc-mark-as-read">Mark all as read</a>
        </div>
        <div class="nfc-dropdown">
          <ng-scrollbar automation-id="header-ng-scrollbar-23" style="height: 350px" visibility="hover">
            <div class="noti-list header-menu">
              <div class="menu">
                <div>
                  @for (notification of notifications; track notification) {
                    <button [attr.automation-id]="'header-button-' + notification.icon" mat-menu-item
                      onClick="return false;"
                      [ngClass]="[notification.status]">
                      <span automation-id="header-span-25" class="table-img msg-user ">
                        <i automation-id="header-i-26" class="material-icons-two-tone nfc-type-icon"
                        [ngClass]="[notification.color]">{{notification.icon}}</i>
                      </span>
                      <span automation-id="header-span-27" class="menu-info">
                        <span automation-id="header-span-28" class="menu-title">{{notification.message}}</span>
                        <span automation-id="header-span-29" class="menu-desc mt-2">
                          <i automation-id="header-i-30" class="material-icons">access_time</i> {{notification.time}}
                        </span>
                      </span>
                      <span automation-id="header-span-31" class="nfc-close">
                        <app-feather-icons automation-id="header-app-feather-icons-32" [icon]="'x'"
                        [class]="'user-menu-icons'"></app-feather-icons>
                      </span>
                    </button>
                  }
                </div>
              </div>
            </div>
          </ng-scrollbar>
        </div>
        <div class="nfc-footer">
          <a automation-id="header-a-33" class="nfc-read-all">Read
          All Notifications</a>
        </div>
      </mat-menu>
    </li>

    <li automation-id="header-li-34">
      <button automation-id="header-button-35" mat-icon-button class="mt-2 nav-notification-icons"
        [ngClass]="((_glob.openCart$)|async)? 'no-pointers' : 'all-pointers'" routerLink="/cart/cart-view"
        style="z-index: 9999999999;margin-right: 23px!important;" >
        <mat-icon automation-id="header-mat-icon-36" class="material-icons-outlined"
          [matBadge]="_glob.productsInCart.length"
          [matBadgeHidden]="_glob.productsInCart.length==0"
        style="vertical-align: middle; color: #DFF4FB;padding-left: 3px;">shopping_cart</mat-icon>

      </button>
    </li>
    <!-- #END# Notifications-->
    <!-- <li  automation-id="header-li-37" class="nav-item">
    <button  automation-id="header-button-38" mat-button [matMenuTriggerFor]="languagemenu" class="lang-dropdown nav-notification-icons"> <img  automation-id="header-img-39"
      *ngIf="flagvalue !== undefined" src="{{flagvalue}}" height="16">
      <img  automation-id="header-img-40" *ngIf="flagvalue === undefined" src="{{defaultFlag}}" height="16"></button>
      <mat-menu  automation-id="header-mat-menu-41" #languagemenu="matMenu" class="lang-item-menu">
        <div *ngFor="let item of listLang" class="lang-item">
          <button  automation-id="header-button-42" mat-menu-item class="dropdown-item lang-item-list"
            (click)="setLanguage(item.text, item.lang, item.flag)"
            [ngClass]="{'active': langStoreValue === item.lang}">
            <img  automation-id="header-img-43" src="{{item.flag}}" class="flag-img" height="12"> <span  automation-id="header-span-44" class="align-middle">{{item.text}}</span>
          </button>
        </div>
      </mat-menu>
    </li> -->

    <!-- #END# Tasks -->
  </ul>
</div>
</div>
</nav>



<!-- <li  automation-id="header-li-45" class="nav-item user_profile" ngbDropdown>
<button  automation-id="header-button-46" class="mt-2" mat-icon-button [matMenuTriggerFor]="profilemenu">
  <div class="chip dropdown-toggle" ngbDropdownToggle class="">
    <span automation-id="header-span-47">Ella Jones</span>
    <mat-icon  automation-id="header-mat-icon-48" style="vertical-align: middle; color: #DFF4FB;margin-right: 10px;">account_circle</mat-icon>
  </div>
</button>
<mat-menu  automation-id="header-mat-menu-49" #profilemenu="matMenu" class="profile-menu">
  <div class="noti-list">
    <div class="menu ">
      <div class="user_dw_menu">
        <button  automation-id="header-button-50" mat-menu-item routerLink="/MaleMan-settings/settings">
          <app-feather-icons  automation-id="header-app-feather-icons-51" [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>Account
        </button>
        <button  automation-id="header-button-52" mat-menu-item>
          <app-feather-icons  automation-id="header-app-feather-icons-53" [icon]="'mail'" [class]="'user-menu-icons'"></app-feather-icons>Inbox
        </button>
        <button  automation-id="header-button-54" mat-menu-item>
          <app-feather-icons  automation-id="header-app-feather-icons-55" [icon]="'settings'" [class]="'user-menu-icons'"></app-feather-icons>Settings
        </button>
        <button  automation-id="header-button-56" mat-menu-item (click)="logout()">
          <app-feather-icons  automation-id="header-app-feather-icons-57" [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>Logout
        </button>
      </div>
    </div>
  </div>
</mat-menu>
</li> -->